import React from "react";
import { Card, CardContent } from "../ui/card";
import Tile from "../../types";
import { Button } from "../ui/button";

interface HeaderTileProps {
  tile: Tile;
  updateTileConfig?: (id: string, config: Partial<Tile["config"]>) => void;
  onEditClick?: () => void;
  setupMode?: boolean;
}

const HeaderTile: React.FC<HeaderTileProps> = ({ tile, onEditClick, setupMode }) => {
  return (
    <Card className="h-full">
      <CardContent className="h-full flex flex-col items-start justify-start space-y-2">
        <div className="flex justify-between w-full items-center">
          <h2 className="text-2xl font-bold">{tile.config?.headerText || "Header Title"}</h2>
          {setupMode && onEditClick && (
            <button
              className="text-sm text-blue-600 underline ml-auto"
              onClick={onEditClick}
            >
              Edit
            </button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};


export default HeaderTile;
